export function isNotNullable<D>(v: D | null | undefined): v is D {
  return !isNullable(v);
}

export function isNullable<T>(v: T | null | undefined): v is null | undefined {
  return v === null || v === undefined;
}
